/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import MaterialTable from "material-table";

export default function TestTable() {
  const [dataStore, setDataStore] = useState([{ name: "Jon", age: 29 },{name: "yash", age:30}]);

  return (
    <div className="container-fluid py-4">
      <div style={{ maxWidth: "100%", paddingTop: "12px" }}>
        <MaterialTable
          columns={[
            {
              title: "Name",
              field: "name"
            },
            {
              title: "Age",
              field: "age"
            },
            {
                title: "Actions",
                field: "Delete"
            }
          ]}
          data={dataStore}
          title="Material-Table Demo"
          options={{
              sorting:true,
              search:false
          }}
        />
      </div>
    </div>
  );
}
